// extracted by mini-css-extract-plugin
module.exports = {"default":"_2bIQPvH1tPDxR4_l_n2ZPH"};